/* Layout */
import Layout from '../views/admin/layout/Layout'
import testLayout from '../views/admin/layout/testLayout'

const asyncRouterMap = [
  /*   ========  ========  ======== */
  /*  ======== MY PETROL ======== */
  /* ========  ========  ======== */
  {
    path: '/z/:branchId/mypetrol/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Profil',
    meta: { relationRoles: ['Owner'], feature: 'mypetrol', title: 'MyPetrol' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/profil_petrol'),
        meta: { title: 'Profil' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/fleetcard',
    component: Layout,
    redirect: '',
    name: 'Fleet Card',
    meta: { relationRoles: ['Owner'], feature: 'mypetrol', title: 'Fleet Card' },
    children: [
      {
        path: 'maklumatfleetcardsemasa',
        component: () => import('@/views/mypetrol/maklumatfleetcardsemasa_petrol'),
        meta: { title: 'Maklumat Fleet Card Semasa' }
      },
      // {
      //   path: 'permohonantambahkenderaan',
      //   component: () => import('@/views/mypetrol/permohonantambahkenderaan_petrol'),
      //   meta: { title: 'Permohonan Tambah Kenderaan' }
      // },
      {
        path: 'tambahkenderaan',
        component: () => import('@/views/mypetrol/tambahkenderaan_petrol'),
        meta: { title: 'Tambah Kenderaan' },
        hidden: true
      },
      {
        path: 'mulatambahkenderaan',
        component: () => import('@/views/mypetrol/mulatambahkenderaan_petrol'),
        meta: { title: 'Tambah Kenderaan' },
        hidden: true
      },
      {
        path: 'mulatambahsyarikatminyak',
        component: () => import('@/views/mypetrol/mulatambahsyarikatminyak_petrol'),
        meta: { title: 'Tambah Syarikat Minyak' },
        hidden: true
      },
      // {
      //   path: 'permohonantambahkenderaan-duplicate',
      //   component: () => import('@/views/mypetrol/permohonantambahkenderaan-duplicate'),
      //   meta: { title: 'DUPLICATE Permohonan Tambah Kenderaan' }
      // },
      // {
      //   path: 'testfile',
      //   component: () => import('@/views/mypetrol/testfile'),
      //   meta: { title: 'Testfile' }
      // },
      // {
      //   path: 'senaraifleetcard',
      //   component: () => import('@/views/mypetrol/senaraifleetcard_petrol'),
      //   meta: { title: 'Senarai Fleet Card' }
      // },
      {
        path: 'permohonanpertukaransyarikatminyak',
        component: () => import('@/views/mypetrol/permohonanpertukaransyarikatminyak_petrol'),
        meta: { title: 'Permohonan Pertukaran Syarikat Minyak' }
      },
      {
        path: 'tuntutan',
        component: () => import('@/views/mypetrol/tuntutan_petrol'),
        meta: { title: 'Tuntutan' },
      },
      
      // {
      //   path: 'rayuan',
      //   component: () => import('@/views/mypetrol/rayuan_petrol'),
      //   meta: { title: 'Rayuan' },
      // },
      {
        path: 'keduatukarsyarikatminyak',
        component: () => import('@/views/mypetrol/keduatukarsyarikatminyak_petrol'),
        meta: { title: 'Tukar Syarikat Minyak' },
        hidden: true
      },
    ],
    noCollapse: true,
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Halaman Utama',
    meta: { relationRoles: ['kpdnadmin', 'enforcer', 'cawanganuser'], feature: 'mypetrol', title: 'Halaman Utama' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/dashboardduplicate_petrol2'),
        meta: { title: 'Halaman Utama' },
        // hidden: true
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/pengguna',
    component: Layout,
    redirect: '',
    name: 'Pengguna',
    meta: { relationRoles: ['kpdnadmin', 'enforcer', 'callcenteruser', 'cawanganuser', 'stateuser'], feature: 'mypetrol', title: 'Pengguna' },
    children: [
      // {
      //   path: 'senaraipengguna_all',
      //   component: () => import('@/views/mypetrol/senaraipengguna_all_petrol'),
      //   meta: { relationRoles: ['kpdnadmin'], title: 'Pengguna Awam [Semua]' }
      // },
      {
        path: 'senaraipengguna',
        component: () => import('@/views/mypetrol/senaraipengguna_petrol'),
        meta: { title: 'Pengguna Awam' }
      },
      {
        path: 'senaraikementerian',
        component: () => import('@/views/mypetrol/senaraikementerian_petrol'),
        meta: { relationRoles: ['kpdnadmin'], title: 'Pengguna Dalaman KPDN' }
      },
      // {
      //   path: 'senaraiagensi',
      //   component: () => import('@/views/mypetrol/senaraiagensi_petrol'),
      //   meta: { title: 'Pengguna Agensi' }
      // },
      {
        path: 'senaraisyarikatminyak',
        component: () => import('@/views/mypetrol/senaraisyarikatminyak_petrol'),
        meta: { relationRoles: ['kpdnadmin'], title: 'Pengguna Syarikat Minyak' },
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/admin',
    component: Layout,
    redirect: '',
    name: 'Fleet Card',
    meta: { relationRoles: ['kpdnadmin', 'enforcer', 'callcenteruser', 'cawanganuser', 'stateuser'], feature: 'mypetrol', title: 'Fleet Card' },
    children: [
      {
        path: 'pemegangakaun',
        component: () => import('@/views/mypetrol/pemegangakaun_petrol'),
        meta: { title: 'Pemegang Akaun' }
      },
      // {
      //   path: 'physicalfleetcard',
      //   component: () => import('@/views/mypetrol/physicalfleetcardadmin_petrol'),
      //   meta: { title: 'Senarai Fleet Card' }
      // },
      // {
      //   path: 'kuota_tambahan',
      //   component: () => import('@/views/mypetrol/kuota_tambahan_petrol'),
      //   meta: { title: 'Kuota Tambahan' }
      // },
      // {
      //   path: 'pembatalan_kuota',
      //   component: () => import('@/views/mypetrol/pembatalan_kuota_petrol'),
      //   meta: { title: 'Pembatalan Kuota' }
      // },
      {
        path: 'pertukaransyarikatminyak',
        component: () => import('@/views/mypetrol/pertukaransyarikatminyak_petrol'),
        meta: { title: 'Pertukaran Syarikat Minyak' },
      },
      // {
      //   path: 'rayuan',
      //   component: () => import('@/views/mypetrol/fleetcardvehicleappeals_petrol'),
      //   meta: { title: 'Rayuan' }
      // },
      {
        path: 'kuotatambahan',
        component: () => import('@/views/mypetrol/kuotatambahan_petrol'),
        meta: { relationRoles: ['kpdnadmin'], title: 'Kuota Tambahan' }
      },
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/mypetrol/rayuan',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Rayuan',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Rayuan' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/mypetrol/fleetcardvehicleappeals_petrol'),
  //       meta: { title: 'Rayuan' }
  //     }
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mypetrol/system',
    component: Layout,
    redirect: '',
    name: 'Pengurusan Sistem',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Pengurusan Sistem' },
    children: [
      // {
      //   path: 'menu_kuota_tambahan',
      //   component: () => import('@/views/mypetrol/halamanutama_petrol'),
      //   meta: { title: 'Tetapan Menu Kuota Tambahan' },
      // },
      // {
      //   path: 'tetapanrekodpenggunaan',
      //   component: () => import('@/views/mypetrol/tetapanrekodpenggunaan_petrol'),
      //   meta: { title: 'Tetapan Rekod Penggunaan Kuota' },
      // },
      // {
      //   path: 'detailrekodpenggunaan',
      //   component: () => import('@/views/mypetrol/detailrekodpenggunaan_petrol'),
      //   meta: { title: 'Detail - Rekod Penggunaan Kuota' },
      // },
      // {
      //   path: 'oilcompanies',
      //   component: () => import('@/views/codestructor/oilcompanies_petrol'),
      //   meta: { title: 'Tetapan Syarikat Minyak' },
      // },
      {
        path: 'senaraibanner',
        component: () => import('@/views/mypetrol/senaraibanner_petrol'),
        meta: { title: 'Senarai Banner' }
      },
      {
        path: 'tetapanjenisbadan',
        component: () => import('@/views/mypetrol/tetapanjenisbadan_petrol'),
        meta: { title: 'Tetapan Jenis Badan' },
      },
      {
        path: 'tetapanjeniskegunaan',
        component: () => import('@/views/mypetrol/tetapanjeniskegunaan_petrol'),
        meta: { title: 'Tetapan Kelas Kegunaan' },
      },
      {
        path: 'dashboardtetapanjenisbadan',
        component: () => import('@/views/mypetrol/dashboardtetapanjenisbadan_petrol'),
        meta: { title: 'Tetapan Deskripsi Umum (Halaman Utama)' },
      },
      {
        path: 'tetapanhargatuntutan',
        component: () => import('@/views/mypetrol/tetapanhargatuntutan_petrol'),
        meta: { title: 'Harga Pam Mingguan' },
      },
      // {
      //   path: 'kandungan_portal',
      //   component: () => import('@/views/mypetrol/kandunganportal_petrol'),
      //   meta: { title: 'Kandungan Portal' },
      // },
      // {
      //   path: 'kandunganbanner',
      //   component: () => import('@/views/mypetrol/kandunganbanner_petrol'),
      //   meta: { title: 'Kandungan Banner' },
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/sekatan',
    component: Layout,
    redirect: '',
    name: 'Sekatan',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Sekatan' },
    children: [
      {
        path: 'senaraisekatan',
        component: () => import('@/views/mypetrol/lparestrictions'),
        meta: { title: 'Senarai Sekatan' }
      },
      // {
      //   path: 'sejarahsekatan',
      //   component: () => import('@/views/mypetrol/sejarahsekatan_petrol'),
      //   meta: { title: 'Sejarah Sekatan' }
      // },
    ],
    alwaysShow: true,
    branch: true
  },
  // {
  //   path: '/z/:branchId/mypetrol/carian',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Carian',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Carian Pemegang Akaun atau Kenderaan' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/mypetrol/halamanutama_petrol'),
  //       meta: { title: 'Carian Pemegang Akaun atau Kenderaan' }
  //     },
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/mypetrol/admin',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Admin',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Admin' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/mypetrol/halamanutama_petrol'),
  //       meta: { title: 'Admin' }
  //     },
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mypetrol/search',
    component: Layout,
    redirect: '',
    name: 'Carian',
    meta: { relationRoles: ['kpdnadmin', 'callcenteruser', 'stateuser'], feature: 'mypetrol', title: 'Carian' },
    children: [
      {
        path: 'jpj',
        component: () => import('@/views/mypetrol/searchjpj_onlineinquiry_petrol'),
        meta: { title: 'Rekod Kenderaan' },
      },
      // {
      //   path: 'jpj_onlineinquiry',
      //   component: () => import('@/views/mypetrol/searchjpj_onlineinquiry_petrol'),
      //   meta: { relationRoles: ['kpdnadmin'], title: 'Rekod Kenderaan Online Inquiry' },
      // },
      {
        path: 'ssm',
        component: () => import('@/views/mypetrol/searchssm_petrol'),
        meta: { title: 'Semakan Data Syarikat' },
      },
      {
        path: 'jpn',
        component: () => import('@/views/mypetrol/searchjpn_petrol'),
        meta: { relationRoles: ['kpdnadmin'], title: 'Semakan Data Pemilikan Tunggal' },
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/laporan',
    component: Layout,
    redirect: '',
    name: 'Laporan',
    meta: { relationRoles: ['kpdnadmin', 'callcenteruser'], feature: 'mypetrol', title: 'Laporan' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/laporan_petrol'),
        meta: { title: 'Laporan' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/testpage',
    component: testLayout,
    redirect: '',
    name: 'Test Page',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Test Page' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/testpage'),
        meta: { title: 'Test Page' }
      },
    ],
    branch: true,
    hidden: true
  },
  {
    path: '/z/:branchId/mypetrol/tuntutan',
    component: Layout,
    redirect: '',
    name: 'Tuntutan',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Tuntutan' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/tuntutanadmin_petrol'),
        meta: { title: 'Tuntutan' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/kpdnprofil',
    component: Layout,
    redirect: '',
    name: 'Profil',
    meta: { relationRoles: ['kpdnadmin', 'callcenteruser', 'stateuser'], feature: 'mypetrol', title: 'Profil' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/kpdnprofil_petrol'),
        meta: { title: 'Profil' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/systemsettingsnextlevel',
    component: Layout,
    redirect: '',
    name: 'Tetapan Sistem',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Tetapan Sistem' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/systemsettings_petrol'),
        meta: { title: 'Tetapan Sistem' },
        hidden: true
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/vehicleownershipchanges',
    component: Layout,
    redirect: '',
    name: 'Log Tukar Hak Milik',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Log Tukar Hak Milik' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/vehicleownershipchange_petrol'),
        meta: { title: 'Log Tukar Hak Milik' },
        hidden: true
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/vehiclebodytypechanges',
    component: Layout,
    redirect: '',
    name: 'Log Tukar Body Type',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Log Tukar Body Type' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/vehiclebodytypechange_petrol'),
        meta: { title: 'Log Tukar Body Type' },
        hidden: true
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/dataraya',
    component: Layout,
    redirect: '',
    name: 'Dataraya',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Dataraya' },
    children: [
      {
        path: 'komprehensif',
        component: () => import('@/views/mypetrol/dataraya_01_komprehensif_petrol'),
        meta: { title: 'Laporan Komprehensif' },
        hidden: true
      },
      {
        path: 'stesenminyak',
        component: () => import('@/views/mypetrol/dataraya_02_stesenminyak_petrol'),
        meta: { title: 'Laporan Maklumat Stesen Minyak' },
        hidden: true
      },
      {
        path: 'fleetcard',
        component: () => import('@/views/mypetrol/dataraya_03_fleetcard_petrol'),
        meta: { title: 'Laporan Maklumat Fleet Card' },
        hidden: true
      },
      {
        path: 'kuota',
        component: () => import('@/views/mypetrol/dataraya_04_kuota_petrol'),
        meta: { title: 'Laporan Maklumat Kuota' },
        hidden: true
      },
      {
        path: 'transaksi',
        component: () => import('@/views/mypetrol/dataraya_05_transaksi_petrol'),
        meta: { title: 'Laporan Maklumat Transaksi' },
        hidden: true
      },
      {
        path: 'pemegangakaun',
        component: () => import('@/views/mypetrol/dataraya_06_pemegangakaun_petrol'),
        meta: { title: 'Laporan Maklumat Pemegang Akaun' },
        hidden: true
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/manual',
    component: Layout,
    redirect: '',
    name: 'Manual',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Manual' },
    children: [
      {
        path: 'manualpegawai',
        component: () => import('@/views/mypetrol/blank_petrol'),
        meta: { title: 'Manual Pegawai' },
      },
      {
        path: 'manualpengguna',
        component: () => import('@/views/mypetrol/blank_petrol'),
        meta: { title: 'Manual Pengguna' },
      },
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/mypetrol/testing',
  //   component: Layout,
  //   redirect: '',
  //   name: 'TESTING',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'TESTING' },
  //   children: [
  //     {
  //       path: 'testingssmcompanies',
  //       component: () => import('@/views/mypetrol/testingssmcompanies_petrol'),
  //       meta: { title: 'SSM Companies' },
  //     },
  //     {
  //       path: 'testingjpjcompanies',
  //       component: () => import('@/views/mypetrol/testingjpjcompanies_petrol'),
  //       meta: { title: 'JPJ Companies' },
  //     },
  //     {
  //       path: 'testingjpjvehicles',
  //       component: () => import('@/views/mypetrol/testingjpjvehicles_petrol'),
  //       meta: { title: 'JPJ Vehicles' },
  //     },
  //     {
  //       path: 'testingmyidentityindividuals',
  //       component: () => import('@/views/mypetrol/testingmyidentityindividuals_petrol'),
  //       meta: { title: 'myIDENTITY Individuals' },
  //     },
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mypetrol/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Halaman Utama',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mypetrol', title: 'MyPetrol' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/halamanutamaoilcompany_petrol'),
        meta: { title: 'Halaman Utama' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol',
    component: Layout,
    redirect: '',
    name: 'Fleet Card',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mypetrol', title: 'Fleet Card' },
    children: [
      {
        path: 'pemegangakaun',
        component: () => import('@/views/mypetrol/pemegangakaunoilcompany_petrol'),
        meta: { title: 'Pemegang Akaun' }
      },
      // {
      //   path: 'physicalfleetcard',
      //   component: () => import('@/views/mypetrol/physicalfleetcardoilcompany_petrol'),
      //   meta: { title: 'Senarai Fleet Card' }
      // },
      {
        path: 'permohonanpertukaransyarikatminyak',
        component: () => import('@/views/mypetrol/permohonanpertukaransyarikatminyakoilcompany_petrol'),
        meta: { title: 'Permohonan Pertukaran Syarikat Minyak' }
      },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/rekodpenggunaan',
    component: Layout,
    redirect: '',
    name: 'Laporan',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mypetrol', title: 'Laporan' },
    children: [
      // {
      //   path: 'rekodpenggunaan',
      //   component: () => import('@/views/mypetrol/rekodpenggunaanoilcompany'),
      //   meta: { title: 'Rekod Penggunaan' }
      // },
      {
        path: 'detailrekodpenggunaanoilcompany',
        component: () => import('@/views/mypetrol/detailrekodpenggunaanoilcompany_uploadversion'),
        meta: { title: 'Laporan Penggunaan Kuota' }
      },
      {
        path: 'detailmonthquotaoilcompany',
        component: () => import('@/views/mypetrol/detailmonthquotaoilcompany_petrol'),
        meta: { title: 'Laporan Pemegang Akaun' }
      },
      // {
      //   path: 'comparisondetailmonthquotaoilcompany',
      //   component: () => import('@/views/mypetrol/comparisondetailmonthquotaoilcompany_petrol'),
      //   meta: { title: 'Bandingan Kuota' }
      // },
      {
        path: 'kuotatambahan',
        component: () => import('@/views/mypetrol/kuotatambahanoilcompany_petrol'),
        meta: { title: 'Laporan Kuota Tambahan' },
        hidden: true
      },
      // {
      //   path: 'percentagechangesoilcompany',
      //   component: () => import('@/views/mypetrol/percentagechangesoilcompany'),
      //   meta: { title: 'Laporan Perubahan Kuota' }
      // },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/sekatan',
    component: Layout,
    redirect: '',
    name: 'Sekatan',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mypetrol', title: 'Sekatan' },
    children: [
      {
        path: 'senaraisekatan',
        component: () => import('@/views/mypetrol/senaraisekatanoilcompany_petrol'),
        meta: { title: 'Senarai Sekatan' }
      },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
  // {
  //   path: '/z/:branchId/mypetrol/banner',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Senarai Banner',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'Banner' },
  //   children: [
  //     {
  //       path: 'senaraibanner',
  //       component: () => import('@/views/mypetrol/senaraibanner_petrol'),
  //       meta: { title: 'Senarai Banner' }
  //     },
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mypetrol/lpagenerator',
    component: Layout,
    redirect: '',
    name: 'LPA Generator',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'LPA Generator' },
    children: [
      {
        path: 'lpagenerator',
        component: () => import('@/views/mypetrol/lpagenerator_petrol'),
        meta: { title: 'LPA Generator' }
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/lpageneratorsapphire',
    component: Layout,
    redirect: '',
    name: 'LPA Generator Sapphire',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'LPA Generator Sapphire' },
    children: [
      {
        path: 'lpageneratorsapphire',
        component: () => import('@/views/mypetrol/lpagenerator_petrol_sapphire'),
        meta: { title: 'LPA Generator Sapphire' }
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/mofgenerator',
    component: Layout,
    redirect: '',
    name: 'MOF Generator',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'MOF Generator' },
    children: [
      {
        path: 'mofgenerator',
        component: () => import('@/views/mypetrol/mofgenerator_petrol'),
        meta: { title: 'MOF Generator' }
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mypetrol/lpadownload',
    component: Layout,
    redirect: '',
    name: 'LPA Download',
    meta: { relationRoles: ['kpdnadmin', 'callcenteruser'], feature: 'mypetrol', title: 'LPA Download' },
    children: [
      {
        path: 'lpadownload',
        component: () => import('@/views/mypetrol/lpadownload_petrol'),
        meta: { title: 'LPA Download' }
      },
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/mypetrol/comparisondownload',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Bandingan Kuota',
  //   meta: { relationRoles: ['kpdnadmin', 'callcenteruser'], feature: 'mypetrol', title: 'Bandingan Kuota' },
  //   children: [
  //     {
  //       path: 'comparisondownload',
  //       component: () => import('@/views/mypetrol/comparisondownload_petrol'),
  //       meta: { title: 'Bandingan Kuota' }
  //     },
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mypetrol/tuntutanold',
    component: Layout,
    redirect: '',
    name: 'tuntutanold',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mypetrol', title: 'tuntutanold' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/tuntutanold_petrol'),
        meta: { title: 'tuntutanold' }
      },
    ],
    hidden: true
  },
  {
    path: '/z/:branchId/mypetrol/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Sekatan',
    meta: { relationRoles: ['enforcer'], feature: 'mypetrol', title: 'Sekatan' },
    children: [
      {
        path: '',
        component: () => import('@/views/mypetrol/senaraisekatan_petrol'),
        meta: { title: 'Senarai Sekatan' }
      },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
]

export default asyncRouterMap


// WEBPACK FOOTER //
// ./src/router/mypetrol.js